export const Type = {
  CAPTION_1: 'caption-l-1',
  CAPTION_2: 'caption-l-2',
  SUBHEADLINE_1: 'subheadline-l-1',
  SUBHEADLINE_2: 'subheadline-l-2',
  TEXT: 'text',
  HEADLINE: 'headline',
  TITLE_1: 'title-l-1',
  TITLE_2: 'title-l-2',
  TITLE_3: 'title-l-3',
} as const;

export type Type = Union<typeof Type>;
